import { get } from "lodash";
import { toTitleCase } from "./html";

const removeAllCaps = (data: unknown): unknown => {
  if (typeof data === "string") {
    return data
      .split(/(<[^>]+>)/g)
      .map((substring) => {
        if (
          substring?.match(/^<[^>]+>$/) ||
          substring !== substring.toUpperCase()
        ) {
          return substring;
        }

        return toTitleCase(substring);
      })
      .join("");
  }

  if (Array.isArray(data)) {
    return data.map(removeAllCaps);
  }

  if (data && typeof data === "object") {
    const obj = data as Record<string, unknown>;
    const newObj: Record<string, unknown> = {};

    for (const key in data) {
      newObj[key] = removeAllCaps(obj[key]);
    }

    return newObj;
  }

  return data;
};

export const getTranslations = (
  data: any = {},
  path = "",
  locale = "en",
  defaultLocale = "en",
): any => {
  const allTranslations = get(data, path);

  if (!Array.isArray(allTranslations)) return;

  const translations = allTranslations.find((t) => {
    const code = t.languages_code?.code || "";

    return code.startsWith(locale) || code.startsWith(defaultLocale);
  });

  if (locale.toLowerCase() === "en-us") return removeAllCaps(translations);

  return translations;
};
